import * as React from 'react';
import { SVGProps } from 'react';

const SvgBackAndNeck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M11.475 6.1H7v30h25v-30h-4.373"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M28.25 9.35h-17.5v-5.5h17.5v5.5Z"
    />
    <path
      fill="currentColor"
      d="M14.113 7.504a.902.902 0 1 0 0-1.804.902.902 0 0 0 0 1.804Zm11.147 0a.902.902 0 1 0 0-1.804.902.902 0 0 0 0 1.804Zm-3.681 6.979c.351 2.33-1.85 4.267-4.131 4.267-2.282 0-4.275-1.915-4.131-4.267.286-4.696 1.73-2.456 3.948-2.592 1.692-.104 3.457-3.092 4.314 2.592Z"
    />
    <path
      fill="currentColor"
      d="M10.912 16.821a1.436 1.436 0 0 1-.312-2.836c.109-.024 2.701-.599 6.728-.932 4.027-.334 6.82-.16 6.932-.152a1.437 1.437 0 0 1 .365 2.792c-.179.06-.367.085-.556.073-.025 0-2.696-.17-6.502.148-3.805.319-6.317.868-6.34.874a1.491 1.491 0 0 1-.315.033Zm12.442 4.984c.535 2.294-1.508 4.399-3.782 4.58-2.274.18-4.412-1.571-4.455-3.928-.086-4.704 1.531-2.584 3.733-2.896 1.674-.237 3.2-3.355 4.504 2.244Z"
    />
    <path
      fill="currentColor"
      d="M12.792 24.982a1.435 1.435 0 0 1-.422-2.809c.105-.032 2.645-.807 6.634-1.46 3.988-.654 6.78-.697 6.896-.699a1.434 1.434 0 0 1 1.047 2.438 1.436 1.436 0 0 1-1.01.433c-.026 0-2.7.044-6.47.662-3.77.617-6.23 1.364-6.253 1.37a1.435 1.435 0 0 1-.422.065Zm12.9 3.605c.877 2.188-.82 4.578-3.04 5.101-2.221.523-4.6-.882-5.001-3.204-.8-4.637 1.12-2.787 3.249-3.43 1.62-.491 2.653-3.805 4.792 1.533Z"
    />
    <path
      fill="currentColor"
      d="M15.52 33.347a1.435 1.435 0 0 1-.628-2.724c.1-.048 2.493-1.196 6.34-2.451 3.848-1.255 6.596-1.72 6.71-1.739a1.436 1.436 0 1 1 .473 2.832c-.025 0-2.663.454-6.293 1.637-3.631 1.183-5.95 2.294-5.974 2.305-.195.094-.41.142-.628.14Z"
    />
    <path
      fill={props.fill}
      d="M6.28 36.875V33.56l23.328-.016 3.338 3.331H6.28Z"
    />
  </svg>
);

export default SvgBackAndNeck;
